import React from 'react'
import TooltipWrapper, { TooltipPosition } from '../TooltipWrapper'
import PanelButton from '../PanelButton'
import styles from './SidePanelMenu.module.scss'
import { SidePanelMenuItemProps, SidePanelMenuItemState } from './types'
import { IconType } from '../Icon'

class SidePanelMenuItem extends React.Component<SidePanelMenuItemProps, SidePanelMenuItemState> {

  state: SidePanelMenuItemState = {
    isOpen: false,
    ref: null
  }
  callbackRef = node => {

    if (typeof node !== 'undefined' && node !== this.state.ref) this.setState({ ref: node })

  }

  handleHover (isOpen) {

    this.setState({ isOpen })

  }

  render () {

    const {
      icon,
      title = '',
      tooltipPosition,
      selected = false,
      colour = IconType.colour.lighterGreen,
      isActive
    } = this.props

    const bdd = this.props.dataBdd ? `sidepanel-menu-item-${this.props.dataBdd}` : 'sidepanel-menu-item'
    const id = this.props.id ? this.props.id : bdd
    let notifications

    if (this.props.notifications) {

      notifications = {
        notifications: this.props.notifications,
        isActive: this.props.isActive
      }

    }

    return <li
      data-bdd={bdd}
      ref={this.callbackRef}
      className={styles['sidemenu-item']}
    >

      <TooltipWrapper
        tooltipText={this.props.tooltipText}
        position={tooltipPosition ? tooltipPosition : TooltipPosition.BOTTOM}
      >
        <PanelButton
          icon={icon}
          selected={selected}
          colour={colour}
          defaultColour={this.props.defaultColour}
          onClick={() => this.props.onClick(this.props.panel, isActive)}
          className={this.props.className}
          id={id}
          notifications={notifications}
        />
      </TooltipWrapper>
    </li>

  }

}

export default SidePanelMenuItem
